import { createContext } from 'react';
import { Analytics } from 'global';

const AnalyticsContext = createContext<Analytics>({
  trackEvent: () => {},
  trackOnboarding: () => {},
  trackStarterGuide: () => {},
  trackRainbow: () => {},
  trackConfiguredForm: () => {},
  trackError: () => {},
});
export default AnalyticsContext;
